<h1 mat-dialog-title>{{ 'legal.title' | transloco }}</h1>
<div mat-dialog-content>
    <p class="legal__content">
        {{ 'legal.paragraph1' | transloco }}
        <br />
        <br />
        {{ 'legal.paragraph2' | transloco }}
        <br />
        <br />
        {{ 'legal.paragraph3' | transloco }}
        <br />
        <br />
        {{ 'legal.paragraph4' | transloco }}
        <br />
        <br />
        {{ 'legal.paragraph5' | transloco }}
        <br />
        <br />
        {{ 'legal.paragraph6' | transloco }}
        <br />
        <br />
        {{ 'legal.paragraph7' | transloco }}
    </p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{ 'legal.close' | transloco }}</button>
</div>
